export const generateToken = (prefix?: string): string => String(prefix || '') + Math.random().toString(36).substring(2)

export const generateId = (arg: string) => (arg || '').toLocaleLowerCase().split(' ').join('_').concat(`_${generateToken()}`)
